import { render } from "./AssetAdminViewModelVersions.vue?vue&type=template&id=2290376a&scoped=true"
import script from "./AssetAdminViewModelVersions.vue?vue&type=script&lang=js"
export * from "./AssetAdminViewModelVersions.vue?vue&type=script&lang=js"

import "./AssetAdminViewModelVersions.vue?vue&type=style&index=0&id=2290376a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2290376a"]])

export default __exports__